import { useEffect } from "react";
import { Row, Col } from "react-flexbox-grid";
import { Link } from "react-router-dom";
import { PageWrapper } from "components";
import { SingleCard } from "components/Main";
import { useGlobalContext } from "context/GlobalContext";
import { withLoader } from "HOC";
import { optionsNavMain } from "constants/index";

import Typography from "@material-ui/core/Typography";
import iconProfile from "assets/images/auth/icons/icon-profile.svg";
import iconSlogan from "assets/images/auth/icons/icon-slogan.svg";

const Main = ({ setLoading }) => {
  const gContext = useGlobalContext();

  const showMessageVaccine = () => {
    gContext.toggleModal({
      title: "COVID19",
      description: "Próximamente podras realizar tu solicitud aquí.",
      okText: "OK",
      onOk: () => gContext.toggleModal(null),
    });
  };

  useEffect(() => {
    setLoading(false);
  }, []);

  return (
    <PageWrapper
      isBack={false}
      header={
        <Row start="xs" middle="xs">
          <Col xs={6}>
            <Row start="xs" middle="xs">
              <h1>
                Hola &nbsp;
                {gContext.currentUser?.name}
              </h1>
            </Row>
          </Col>
          <Col xs={6}>
            <Row end="xs" middle="xs">
              <Link to="/cuenta">
                <img
                  src={gContext.currentUser?.profileUrl || iconProfile}
                  width="40px"
                  height="40px"
                  className="br-100 cover"
                  alt="icon-profile"
                />
              </Link>
            </Row>
          </Col>
        </Row>
      }
    >
      <Col md={12}>
        <Row center="xs">
          <img src={iconSlogan} alt="slogan" height="64px" />
        </Row>
      </Col>
      {optionsNavMain.map(({ to, text, icon }) => {
        return (
          <SingleCard
            key={to}
            onClick={to === "/" ? showMessageVaccine : () => null}
            to={to}
            title={text}
            icon={icon}
          />
        );
      })}

      <Col md={12} className="mt4">
        <Row center="xs">
          <Typography variant="body2" component="p">
            No esperes más,
            <strong> comienza el cambio hoy.</strong>
          </Typography>
        </Row>
      </Col>
    </PageWrapper>
  );
};

export default withLoader(Main, "Cargando inicio");
